export const Status = {
  During: 'W trakcie',
  Signed: 'Podpisano',
  Overdue: 'Przekroczono',
};
